export enum CollectionName {
  CLIENT = "clients",
  USER = "users",
  DEVICE = "devices",
  UTIL = "utils",
  TOKEN = "token",
  ACCOUNT_LINK = "accountLinkings",
  TEMP_CLIENT = "temporaryClient",
}
